// The avatars a bot can be given, and everything that follows from the choice:
// which renderer draws it, which neural voice it speaks with, and the face shown
// in the collapsed header and on each reply bubble.
//
// Adding a fourth avatar is one entry here plus its assets.
import modelThumb from "./avatar_bio.png";
import { SPRITE_THUMBS } from "./sprites";

// How the avatar is drawn: a three.js scene, or stacked 2D layers.
export const AvatarKind = {
  MODEL: "model",
  SPRITE: "sprite",
};

export const AVATARS = [
  {
    id: "avatar_3d",
    label: "Alex",
    description: "3D model with live lip-sync",
    kind: AvatarKind.MODEL,
    // Each avatar names its own voice; the backend's _VOICE_MAP
    // (domains/tts/tts_routes.py) maps it to a Microsoft neural voice.
    voice: "sam",
    thumb: modelThumb,
  },
  {
    id: "avatar_amy",
    label: "Amy",
    description: "Illustrated, female voice",
    kind: AvatarKind.SPRITE,
    voice: "aria",
    sprite: "female",
    thumb: SPRITE_THUMBS.female,
    // How far under its recent peak (dB) the voice must fall for each mouth
    // frame — see AvatarSprite. Lower closeBelowDb to shut the mouth more often.
    lipSync: { closeBelowDb: 10, smallBelowDb: 6, wideWithinDb: 2 },
  },
  {
    id: "avatar_jason",
    label: "Jason",
    description: "Illustrated, male voice",
    kind: AvatarKind.SPRITE,
    voice: "ryan",
    sprite: "male",
    thumb: SPRITE_THUMBS.male,
    lipSync: { closeBelowDb: 10, smallBelowDb: 6, wideWithinDb: 2 },
  },
];

export const DEFAULT_AVATAR_ID = "avatar_3d";

/**
 * Resolve a stored `avatar_id` to its avatar.
 *
 * Bots saved before the avatars were real hold a placeholder id (avatar_01 …
 * avatar_06, which only ever picked an emoji), so anything unrecognised falls
 * back to the default rather than leaving the panel with no face at all.
 */
export const getAvatar = (avatarId) =>
  AVATARS.find((avatar) => avatar.id === avatarId) ||
  AVATARS.find((avatar) => avatar.id === DEFAULT_AVATAR_ID);
